























import { Vue, Component } from "vue-property-decorator";
import LectureFormEdit from "@/components/lectures/LectureFormEdit.vue";
import * as model from "@/api/models";
import api from "@/getinfo-api";
import { AxiosError } from "axios";
import CBreadCrumbs from "@/components/form/CustomPage/CBreadCrumbs.vue";
@Component({
  components: { CBreadCrumbs, LectureFormEdit }
})
export default class LectureEdit extends Vue {
  lectureInfo!: model.Lecture;
  data() {
    return {
      lectureInfo: undefined
    };
  }

  get breadcrumbs() {
    return [
      {
        to: { name: "lectureList" },
        label: `${this.$tc(this.$translate.Lectures)}`
      },
      {
        to: { name: "lecture", params: { id: this.lectureInfo.id } },
        label: this.$converter.limitedOutput(this.lectureInfo.title, 60)
      },
      {
        label: this.$tc(this.$translate.Edit)
      }
    ];
  }
  goBack() {
    this.$router.go(-1);
  }

  getInfoAboutLectures() {
    api.LectureApi.get(this.$route.params.id)
      .then((res: { data: model.Lecture }) => {
        this.lectureInfo = res.data;
        document.title += ` ${this.lectureInfo.title}`;
      })
      .catch((error: AxiosError<model.ErrorResponse>) => {
        if (error.response) {
          this.$bvToast.toast(error.response.data.message, {
            variant: "danger",
            title: "Error"
          });
        } else {
          this.$bvToast.toast(`${this.$tc(this.$translate.UnknownError)}`, {
            variant: "danger",
            title: "Error"
          });
        }
      });
  }

  get lecture() {
    return this.$store.getters.SELECTED_LECTURE;
  }

  created() {
    this.getInfoAboutLectures();
    this.$store.dispatch("GET_LECTURE", this.$route.params.id);
  }
}
